import axios from 'axios';

let api =  axios.create({
    baseURL: base.site_url + '/wp-json/acf/v3/options/options',
});

export default api;
